export default __webpack_public_path__ + "static/media/ICON10.7f5b0766.svg";